import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import { styledMedia } from "../mediaquery/breakpoints";
import { getUid } from "../../../utils/uid";

const EllipsisButton = styled.span`
  cursor: pointer;
`;

const EllipsisTooltip = styled.span`
  transition: visibility 0s linear 0.5s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.5);
  position: absolute;
  border-radius: 1px;
  bottom: ${props => (props.position ? "-35px" : "0px")};
  right: 0;
  line-height: 1.2rem;
  max-width: 285px;
  min-width: 150px;
  background-color: ${cloud.getShade(2)};
  padding: 5px;
  text-align: left;
  font-size: 1.2rem;
  color: ${cloud.getShade(10)};
  z-index: 1;
  ${styledMedia.small`
    max-width: 250px;
    left: 0;
  `}

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition-delay: 0s;
  }
`;

class ToolTipButton extends Component {
  constructor() {
    super();
    this.state = { ariaHidden: true };
    this.toolTipId = getUid("ToolTipButton");
  }

  addAriaHidden = () => {
    this.setState({ ariaHidden: true });
  };

  removeAriaHidden = () => {
    this.setState({ ariaHidden: false });
  };

  handleEscKey = e => {
    if (e.keyCode === 27) {
      this.addAriaHidden();
    }
  };

  render() {
    return (
      <span>
        <EllipsisButton
          aria-describedby={this.toolTipId}
          aria-label={this.props.toolTipText}
          tabIndex={0}
          onMouseOver={this.removeAriaHidden}
          onMouseLeave={this.addAriaHidden}
          onFocus={this.removeAriaHidden}
          onBlur={this.addAriaHidden}
          onKeyDown={this.handleEscKey}
          onKeyUp={this.handleEscKey}
        >
          ...
        </EllipsisButton>
        <EllipsisTooltip
          aria-hidden={this.state.ariaHidden}
          id={this.toolTipId}
          role="tooltip"
          position={!!this.props.position}
        >
          {this.props.toolTipText}
        </EllipsisTooltip>
      </span>
    );
  }
}

export default ToolTipButton;
